/// <reference path="DOMAttached.js" />
/// <reference path="UrlTemplate.js" />
/// <reference path="TextResource.js" />
/// <reference path="LegacyHelper.js" />
/// <reference path="LegacyEffects.js" />

class GamesMathPuzzle extends DOMAttached {
	constructor(el, options) {
		super(el, options);
		var splash = this.el.querySelector('.splash');

		if (this.options.level == '1') {
			splash.querySelector('.background').style.opacity = 0.7;
			this.demoMode = true;
			this.el.querySelector('.levelDown').style.display = 'none';
		} else {
			splash.style.display = 'none';
			this.demoMode = false;
		}

		this.medalImage = this.el.querySelector('.medalBox').querySelector('.medal');
		this.happySmiley = this.el.querySelector('.medalBox').querySelector('.win');
		this.sadSmiley = this.el.querySelector('.medalBox').querySelector('.fail');
		this.levelUpOverlay = this.el.querySelector('.levelUpOverlay');

		// register click handler

		this.safeObserve(document.querySelectorAll('.splashClose')[0], 'click', (ev) => {
			if (typeof(ev) != 'undefined') {
				ev.preventDefault();
				ev.stopPropagation();
			}
			this.el.querySelector('.splash').style.display = 'none';
		});

		this.safeObserve(this.el.querySelector('.levelUpButton'), 'click', (ev) => {
			if (typeof(ev) != 'undefined') {
				ev.preventDefault();
				ev.stopPropagation();
			}
			this.showNextOverlayContent();
		});

		this.safeObserve(this.el.querySelector('.medalOkButton'), 'click', (ev) => {
			if (typeof(ev) != 'undefined') {
				ev.preventDefault();
				ev.stopPropagation();
			}
			this.showNextOverlayContent();
		});

		this.safeObserve(this.el.querySelector('.levelDown'), 'click', (ev) => {
			axios(new UrlTemplate(this.options.levelJumpUrl)
			.r('PLH_level', -1).url, {
				method: 'get'
			}).then(this.ajajCallHandler.bind(this));
			if (typeof(ev) != 'undefined') {
				ev.preventDefault();
				ev.stopPropagation();
			}
		});

		this.setRunningEffects();
		this.originalPuzzle = this.el.querySelector('.questionContainer').innerHTML;
		this.initialOperations();
		this.resetTimer();
		this.startTimer();
	}

	getHint() {
		switch (this.solution[0]) {
			case undefined:
				return '';
			case 'Addition':
				return this.options.trAdditionHint;
			case 'Subtraction':
				return this.options.trSubtractionHint;
			case 'Multiplication':
				return this.options.trMultiplicationHint;
			case 'Division':
				return this.options.trDivisionHint;
			default:
				return new TextResource(this.options.trOperandHint).r('{operand}', this.solution[0]).string();
		}
	}

	showHint() {
		this.addAfterAllEffectsFinishedFunction(function() {
			var newHint = this.getHint();
			if (this.hint.querySelector('.text').innerHTML != newHint) {
				if (this.hint.style.display == 'none') {
					this.hint.querySelector('.text').innerHTML = newHint;
					LegacyEffects.appear(this.hint);
				} else {
					LegacyEffects.fade(this.hint, {
						onComplete: () => {
							this.hint.querySelector('.text').innerHTML = newHint;
							LegacyEffects.appear(this.hint);
						}
					});
				}
			}
		}.bind(this));
	}

	nextHint() {
		this.solution.shift();
		if (this.solution.length > 0) {
			this.showHint();
		}
	}

	setRunningEffects(change) {
		if (change == undefined) {
			this.runningEffects = 0;
			this.afterAllEffectsFinished = new Array();
		} else {
			this.runningEffects += change;
			if (this.runningEffects == 0) {
				for (var i = 0; i < this.afterAllEffectsFinished.length; i++) {
					this.afterAllEffectsFinished[i]();
				}
				this.afterAllEffectsFinished = new Array();
			}
		}
	}

	addAfterAllEffectsFinishedFunction(func) {
		if (this.runningEffects == 0) {
			func();
		} else {
			this.afterAllEffectsFinished.push(func);
		}
	}

	// operation that should be performed whenever MathPuzzleContainer is loaded
	initialOperations() {

		var demoModeButton = this.el.querySelector('.DemoModeButton');

		this.hint = this.el.querySelector('.hint');
		if (legacyGlobal.isIE) {
			this.hint.querySelectorAll('*').forEach(function(el) {
				el.style.filter = 'inherit';
			});
		}

		if (this.demoMode) {
			demoModeButton.querySelector('.end').style.display = '';
			demoModeButton.querySelector('.start').style.display = 'none';
			this.hint.style.display = 'none';
			this.hint.style.visibility = 'visible';
			this.solution = this.el.querySelector('.questionContainer').querySelector('div').querySelector('.solution').innerHTML.split("|");
			this.showHint();
		} else {
			demoModeButton.querySelector('.end').style.display = 'none';
			demoModeButton.querySelector('.start').style.display = '';
			this.hint.style.display = 'none';
			this.hint.style.visibility = 'visible';
		}

		if (this.showTryOnYourOwnInfo == true) {
			this.hint.style.display = '';
			this.hint.querySelector('.text').innerHTML = this.options.trTryOnYourOwn;
			LegacyEffects.appear(this.hint, {
				onComplete: () => {
					LegacyEffects.fade(this.hint, { delay: 3.0 });
				}
			});
			this.showTryOnYourOwnInfo = false;
		}
		var questionContainerDimensions = { width: this.el.querySelector('.questionContainer').offsetWidth, height: this.el.querySelector('.questionContainer').offsetHeight };
		this.leftOperandPosition = { left: questionContainerDimensions.width / 2 - this.options.operatorSize / 2 - this.options.operandSize, top: questionContainerDimensions.height / 2 - this.options.operandSize / 2 };
		this.operatorPosition = { left: questionContainerDimensions.width / 2 - this.options.operatorSize / 2, top: questionContainerDimensions.height / 2 - this.options.operatorSize / 2 };
		this.rightOperandPosition = { left: questionContainerDimensions.width / 2 + this.options.operatorSize / 2, top: questionContainerDimensions.height / 2 - this.options.operandSize / 2 };

		this.duration = 0.4;

		this.resetInput(true, true, true);

		document.querySelectorAll('.OperatorButton').forEach(function(btn) {
			btn.unmove = undefined;
			btn.locked = undefined;
		}.bind(this));

		document.querySelectorAll('.OperandButton').forEach(function(btn) {
			btn.unmove = undefined;
			btn.locked = undefined;
		}.bind(this));

		// register operand buttons
		var i = 0;
		document.querySelectorAll('.OperandButton').forEach(function(btn) {
			btn.number = i++;
			this.safeObserve(btn.querySelector('.bubble-button'), 'click', function(ev) {
				if (this.globalLock == true) return;
				if (this.demoMode && btn.querySelector('.bubble-button').innerHTML != this.solution[0]) { // user must follow the hints
					return;
				}

				if (this.operand1 == undefined) { // first operand selected
					this.selectOperand1(btn);
				} else if (this.operand2 == undefined) { // already two operands selected
					if (btn.number != this.operand1) {
						this.selectOperand2(btn);
					} else if (!this.demoMode) { // reset because first operand == second operand
						this.resetInput(true, true, true);
					}
				} else if (!this.demoMode) { // already selected two operands
					if (btn.number == this.operand1) { // select first operand
						this.resetInput(false, false, true);
					} else if (btn.number != this.operand2) { // select other operand
						this.resetInput(true, false, true);
						this.selectOperand1(btn);
					}
				}
			}.bind(this));
		}.bind(this));

		// register operator buttons
		var j = 0;
		document.querySelectorAll('.OperatorButton').forEach(function(btn) {
			btn.number = j++;
			this.safeObserve(btn.querySelector('.bubble-button'), 'click', function(ev) {
				if (this.operator == undefined) {
					if (this.demoMode && btn.title != this.solution[0]) { // user must follow the hints
						return;
					}
					this.selectOperator(btn);
				} else if (!this.demoMode) {
					this.resetInput(false, true, false);
				}
			}.bind(this));
		}.bind(this));

		this.undoPossible = false;

		// register undo button
		this.safeObserve(this.el.querySelector('.UndoButton'), 'click', function(ev) {
			if (this.demoMode) { // do not allow 'undo' in demo mode	
				return;
			}
			if (this.operand1 != undefined || this.operator != undefined || this.operand2 != undefined) {
				this.seconds += 5;
				this.blinkingSmiley(this.sadSmiley);
				this.addAfterAllEffectsFinishedFunction(function() {
					this.resetInput(true, true, true);
				}.bind(this));
			} else if (this.undoPossible) {
				this.seconds += 5;
				this.blinkingSmiley(this.sadSmiley);
				axios(new UrlTemplate(this.options.undoUrl).url, {
					method: 'get'
				}).then(this.ajajCallHandler.bind(this));
			}
		}.bind(this));

		// register demo mode button
		this.safeObserve(this.el.querySelector('.DemoModeButton'), 'click', function(ev) {
			this.demoMode = !this.demoMode;
			if (this.demoMode == false) {
				this.showTryOnYourOwnInfo = true;
				axios(new UrlTemplate(this.options.levelJumpUrl)
				.r('PLH_level', 0).url, {
					method: 'get'
				}).then(this.ajajCallHandler.bind(this));
			} else {
				this.pauseTimer();
				axios(new UrlTemplate(this.options.undoAllUrl).url, {
					method: 'get'
				}).then(() => {
					this.addAfterAllEffectsFinishedFunction(() => {
						var container = this.el.querySelector('.questionContainer');
						LegacyEffects.fade(container, {
							onComplete: () => {
								container.innerHTML = this.originalPuzzle;
								LegacyEffects.appear(container);
								this.initialOperations();
								this.resetInput(true, true, true);
							}
						});
					});
				});
			}
		}.bind(this));

	}

	move(btn, dx, dy) {
		if (btn.locked == undefined) {
			btn.locked = true;
			if (btn.classList.contains('OperatorButton')) {
				document.querySelectorAll('.OperatorButton').forEach((otherOperator) => {
					if (otherOperator != btn) {
						LegacyEffects.fade(otherOperator);
					}
				});
			}
			var dxOld = btn.dx;
			var dyOld = btn.dy;
			btn.dx = dx;
			btn.dy = dy;
			LegacyEffects.move(btn, {
				x: btn.dx,
				y: btn.dy,
				mode: 'relative',
				duration: this.duration,
				onStart: () => { 
					this.setRunningEffects(1);
				},
				onComplete: () => {
					this.setRunningEffects(-1);
					btn.locked = undefined;
					if (btn.unmove) {
						this.unmove(btn);
					}
				}
			});
			if (dxOld != undefined && dyOld != undefined) {
				btn.dx += dxOld;
				btn.dy += dyOld;
			}
			return true;
		} else {
			return false;
		}
	}

	unmove(btn) {
		if (btn.locked == undefined && btn.dx != undefined && btn.dy != undefined) {
			btn.locked = true;
			btn.unmove = undefined;
			LegacyEffects.move(btn, {
				x: -btn.dx,
				y: -btn.dy,
				mode: 'relative',
				duration: this.duration,
				onStart: () => {
					this.setRunningEffects(1);
				},
				onComplete: () => {
					this.setRunningEffects(-1);
					btn.locked = undefined;
					if (btn.classList.contains('OperatorButton')) {
						LegacyEffects.appear('.OperatorButton');
					}
				}
			});
			btn.dx = undefined;
			btn.dy = undefined;
		} else {
			btn.unmove = true;
		}
	}

	selectOperand1(btn) {
		if (this.operand1 != undefined && this.operand1 != btn.number) {
			this.deselectOperand1();
		}
		if (this.operand1 == undefined) {
			if (this.move(btn, this.leftOperandPosition.left - btn.offsetLeft, this.leftOperandPosition.top - btn.offsetTop)) {
				this.operand1 = btn.number;
			}
		}
		this.checkTerm();
	}

	deselectOperand1() {
		if (this.operand1 != undefined) {
			var btn = document.querySelectorAll('.OperandButton')[this.operand1];
			this.operand1 = undefined;
			this.unmove(btn);
		}
	}

	selectOperand2(btn) {
		if (this.operand2 != undefined && this.operand2 != btn.number) {
			this.deselectOperand2();
		}
		if (this.operand2 == undefined) {
			if (this.move(btn, this.rightOperandPosition.left - btn.offsetLeft, this.rightOperandPosition.top - btn.offsetTop)) {
				this.operand2 = btn.number;
			}
		}
		this.checkTerm();
	}

	deselectOperand2() {
		if (this.operand2 != undefined) {
			var btn = document.querySelectorAll('.OperandButton')[this.operand2];
			this.operand2 = undefined;
			this.unmove(btn);
		}
	}

	selectOperator(btn) {
		if (this.operator != undefined && this.operator != btn.number) {
			this.deselectOperator();
		}
		if (this.operator == undefined) {
			if (this.move(btn, this.operatorPosition.left - (btn.offsetLeft + btn.parentNode.offsetLeft), this.operatorPosition.top - (btn.offsetTop + btn.parentNode.offsetTop))) {
				this.operator = btn.number;
			}
		}
		this.checkTerm();
	}

	checkTerm() {
		if (this.operand1 != undefined && this.operator != undefined && this.operand2 != undefined) {
			axios(new UrlTemplate(this.options.performOperationUrl)
			.r('PLH_Operations', document.querySelectorAll('.OperatorButton')[this.operator].title)
			.r('PLH_term1', this.operand1)
			.r('PLH_term2', this.operand2)
			.r('PLH_time', this.seconds)
			.r('PLH_demoMode', this.demoMode).url, {
				method: 'get'
			}).then(this.ajajCallHandler.bind(this));
		} else if (this.demoMode) {
			this.nextHint();
		}
	}

	deselectOperator() {
		if (this.operator != undefined) {
			var btn = document.querySelectorAll('.OperatorButton')[this.operator];
			this.operator = undefined;
			this.unmove(btn);
		}
	}

	resetInput(operand1, operator, operand2) {
		if (operand1) {
			this.deselectOperand1();
		}
		if (operator) {
			this.deselectOperator();
		}
		if (operand2) {
			this.deselectOperand2();
		}
	}

	ajajCallHandler(req) {
		this.json = req.data;

		if (this.json.invalidOperation != undefined) {
			this.resetInput(true, true, true);
		} else if (this.json.result != undefined) {
			var operand1 = document.querySelectorAll('.OperandButton')[this.operand1];
			var operand2 = document.querySelectorAll('.OperandButton')[this.operand2];
			var operator = document.querySelectorAll('.OperatorButton')[this.operator];

			this.globalLock = true;

			this.setRunningEffects(1);

			LegacyEffects.parallel(
				[
					LegacyEffects.fade(operator),
					LegacyEffects.fade(operand1),
					LegacyEffects.fade(operand2)
				], {
					onComplete: () => {
						if (this.json.page != undefined) {
							var isWin = this.demoMode || this.json.levelUp || this.json.progress > 0;
							const imgElement = operand2.querySelector('.img');
							if (imgElement) {
								imgElement.classList.toggle("win", isWin);
								imgElement.classList.toggle("fail", !isWin);
							}
						}

						operand2.querySelector('.bubble-button').innerHTML = this.json.result;
						var originalx = parseFloat(window.getComputedStyle(operand2).getPropertyValue("left") || '0');
						var dx = Math.floor((this.leftOperandPosition.left - this.rightOperandPosition.left) / 2);
						operand2.style.left = (originalx + dx) + 'px';
						operand2.dx += dx;
						LegacyEffects.appear(operand2, {
							onComplete: () => {
								this.globalLock = undefined;
								if (this.json.page == undefined) {
									this.resetInput(true, true, true);
								}
								this.setRunningEffects(-1);
							}
						})
					}
				}
			);

			if (this.demoMode) {
				this.nextHint();
			}

			this.undoPossible = this.json.undoPossible;

		}

		if (this.json.page != undefined) { // new math puzzle

			this.originalPuzzle = this.json.page;

			this.addAfterAllEffectsFinishedFunction(() => {
				this.undoPossible = false;

				var container = this.el.querySelector('.questionContainer');

				if (this.json.result != undefined) {
					var operand2 = document.querySelectorAll('.OperandButton')[this.operand2];
					if (this.demoMode || this.json.levelUp || this.json.progress > 0) {
						LegacyEffects.move(operand2, { x: 0, y: -150, mode: 'relative' });
					} else {
						LegacyEffects.move(operand2, { x: 0, y: 150, mode: 'relative' });
					}
				}

				LegacyEffects.fade(container, {
					onComplete: () => {
						container.innerHTML = this.json.page;
						LegacyEffects.appear(container);

						if (this.json.progressBar != undefined) {
							replaceElement(this.el.querySelector('.progressBar'), this.json.progressBar);
						}

						if (this.json.personalRecordBox != undefined) {
							replaceElement(this.el.querySelector('.personalRecordBox'), this.json.personalRecordBox);
						}

						if (this.json.overallRecordBox != undefined) {
							replaceElement(this.el.querySelector('.overallRecordBox'), this.json.overallRecordBox);
						}

						var progressBar = this.el.querySelector('.progressBar');

						for (var i = 0; i < this.json.maxProgress; i++) {
							if (i < this.json.progress) {
								progressBar.querySelectorAll('.greySegment')[i].style.visibility = 'hidden';
								progressBar.querySelectorAll('.yellowSegment')[i].style.visibility = 'visible';
							} else {
								progressBar.querySelectorAll('.yellowSegment')[i].style.visibility = 'hidden';
								progressBar.querySelectorAll('.greySegment')[i].style.visibility = 'visible';
							}
						}

						this.el.querySelector('.currentLevel').innerHTML = 'Level: ' + this.json.level;
						this.el.querySelector('.levelDown').style.display = (this.json.level == 1 ? "none" : "");

						if (this.demoMode || this.json.levelUp || this.json.progress > 0) {
							this.blinkingSmiley(this.happySmiley);
						} else {
							this.blinkingSmiley(this.sadSmiley);
						}

						if (this.demoMode) {
							this.demoMode = false;
							this.showTryOnYourOwnInfo = true;
						}

						this.showNextOverlayContent();

						this.initialOperations();

						this.resetInput(true, true, true);
					}
				});

			});

		} else if (this.json.idx1 != undefined) { // undo
			this.undoPossible = this.json.undoPossible;
			document.querySelectorAll('.OperandButton')[this.json.idx1].querySelector('.bubble-button').innerHTML = this.json.result1;
			document.querySelectorAll('.OperandButton')[this.json.idx1].style.display = '';
			document.querySelectorAll('.OperandButton')[this.json.idx2].querySelector('.bubble-button').innerHTML = this.json.result2;
			document.querySelectorAll('.OperandButton')[this.json.idx2].style.display = '';
			this.resetInput.bind(this).delay(1, true, true, true);
		}

	}

	blinkingSmiley(smiley) {
		smiley.style.display = 'none';
		smiley.style.visibility = 'visible';
		LegacyEffects.fade(this.medalImage);
		LegacyEffects.appear(smiley, {
			onComplete: () => {
				LegacyEffects.pulsate(smiley, {
					pulses: 2,
					duration: 1.5,
					onComplete: () => {
						LegacyEffects.fade(smiley);
						LegacyEffects.appear(this.medalImage);
					}
				});
			}
		});
	}

	showNextOverlayContent() {
		this.pauseTimer();
		if (this.json.medal != undefined && !this.json.medal.endsWith("games/medals/medal_none.svg")) { // show medal in level up overlay

			// hide some content of overlay
			this.levelUpOverlay.querySelector('.level').style.display = 'none';
			this.levelUpOverlay.querySelector('.levelUpButton').style.display = 'none';
			this.levelUpOverlay.querySelector('.continueButton').style.display = 'none';
			// show some content of overlay
			this.levelUpOverlay.querySelector('.medalOkButton').style.display = 'block';
			this.levelUpOverlay.querySelector('.image').style.display = "block";
			this.levelUpOverlay.querySelector('.imageCaption').style.display = "block";
			// set content to show
			this.levelUpOverlay.querySelector('.infoText').innerHTML = this.options.trMedalMessage;
			this.levelUpOverlay.querySelector('.image').querySelector('img').src = this.json.medal;
			this.levelUpOverlay.querySelector('.imageCaption').innerHTML = this.json.medalName;
			this.medalImage.src = this.json.medal;
			// prevent from showing the medal again
			this.json.medal = undefined;
			this.levelUpOverlay.style.display = 'block';

		} else if (this.json.levelUp && this.json.level > 1) {
			// hide some content of overlay
			this.levelUpOverlay.querySelector('.medalOkButton').style.display = 'none';
			this.levelUpOverlay.querySelector('.image').style.display = 'none';
			this.levelUpOverlay.querySelector('.imageCaption').style.display = 'none';
			this.levelUpOverlay.querySelector('.levelUpButton').style.display = 'block';
			this.levelUpOverlay.querySelector('.infoText').innerHTML = new TextResource(this.options.trLevelReached).r('{level}', this.json.level).r('{amount}', this.json.amount).string();
			this.levelUpOverlay.querySelector('.level').style.display = 'block';
			// set content to show
			if (this.json.overallRecord) {
				this.levelUpOverlay.querySelector('.level').innerHTML = new TextResource(this.options.trOverallRecord).r('{seconds}', this.json.timeInSeconds).string();
			} else if (this.json.personalRecord) {
				this.levelUpOverlay.querySelector('.level').innerHTML = new TextResource(this.options.trPersonalRecord).r('{seconds}', this.json.timeInSeconds).string();
			} else {
				this.levelUpOverlay.querySelector('.level').innerHTML = new TextResource(this.options.trLevelTime).r('{seconds}', this.json.timeInSeconds).string();
			}
			// 'Level: ' + this.json.level;	
			//prevent from showing level up info again
			this.json.levelUp = undefined;
			this.levelUpOverlay.style.display = 'block';

		} else if (this.json.pet != undefined && this.json.pet != "") { // show pet in level up overlay

			// hide some content of overlay
			this.levelUpOverlay.querySelector('.medalOkButton').style.display = 'none';
			this.levelUpOverlay.querySelector('.level').style.display = 'none';
			this.levelUpOverlay.querySelector('.continueButton').style.display = 'none';
			// show some content of overlay
			this.levelUpOverlay.querySelector('.levelUpButton').style.display = 'block';
			this.levelUpOverlay.querySelector('.image').style.display = "block";
			this.levelUpOverlay.querySelector('.imageCaption').style.display = "block";
			// set content to show
			this.levelUpOverlay.querySelector('.infoText').innerHTML = this.options.trPetMessage;
			this.levelUpOverlay.querySelector('.image').querySelector('img').src = this.json.pet;
			this.levelUpOverlay.querySelector('.imageCaption').innerHTML = this.json.petName;
			// prevent from showing the pet again
			this.json.pet = undefined;
			this.levelUpOverlay.style.display = 'block';

		} else if (this.json.levelUp && this.json.level == 1) { // show end of game message in overlay
			// hide some content of overlay
			this.levelUpOverlay.querySelector('.level').style.display = 'none';
			this.levelUpOverlay.querySelector('.image').style.display = 'none';
			this.levelUpOverlay.querySelector('.imageCaption').style.display = 'none';
			this.levelUpOverlay.querySelector('.levelButtons').style.display = 'none';
			// show some content of overlay
			this.levelUpOverlay.querySelector('.continueButton').style.display = 'block';
			// set content to show
			this.levelUpOverlay.querySelector('.infoText').innerHTML = new TextResource(this.options.trEndOfGame).r('{amount}', this.json.amount).r('{newreward}', this.json.newreward).string();
			// prevent from shopwing end of game message again
			this.json.levelUp = undefined;
			this.levelUpOverlay.style.display = 'block';

		} else { // close level up overlay
			this.levelUpOverlay.style.display = 'none';
			if (this.json.progress == 0) {
				this.resetTimer();
			}
			if (!this.demoMode) {
				this.startTimer();
			}
		}
	}

	startTimer() {
		if (this.timer == undefined) {
			this.increaseTimer();
			this.timer = setInterval(this.increaseTimer.bind(this), 1000);
		}
	}

	pauseTimer() {
		if (this.timer != undefined) {
			clearInterval(this.timer);
			this.seconds--;
			this.timer = undefined;
		}
	}

	resetTimer() {
		if (this.timer != undefined) {
			clearInterval(this.timer);
			this.timer = undefined;
		}
		this.seconds = -1;
		this.el.querySelector('.timer').innerHTML = "00:00";
	}

	increaseTimer() {
		this.seconds++;

		var string = Math.floor(this.seconds % 60);
		if (String(string).length < 2) string = '0' + string;
		string = Math.floor(this.seconds / 60) + ':' + string;
		if (string.length < 5) string = '0' + string;

		this.el.querySelector('.timer').innerHTML = string;
	}
}
